const excludeLoadingUrl = {
  renderBatchLabel: 'renderBatchLabel',
  fetchBatchLabel: 'fetchBatchLabel',
};

export { excludeLoadingUrl };
